import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ErrorMessage } from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';

export interface PasscodeFormProps {
  employeeId: string;
  formId: string;
  onValidPasscode: () => void;
  onFailedPasscode: () => void;
}

export const PasscodeForm = ({
  employeeId,
  formId,
  onValidPasscode,
  onFailedPasscode,
}: PasscodeFormProps) => {
  const { t } = useTranslation(['common']);
  const { handleSubmit, handleChange, values, errors, touched } = useFormik({
    initialValues: {
      passcode: '',
    },
    onSubmit: async (values) => {
      // const passcodeDoc = await getDoc(
      //   getSurveyPasscodeDocRef(company.id, `${employeeId}-${formId}`)
      // );
      // if (passcodeDoc.exists()) {
      //   const passcode = FirestoreSurveyPasscode.fromFirestore(passcodeDoc, {});
      //   if (passcode.passcode === values.passcode) {
      //     // Navigate to the form
      //     onValidPasscode();
      //   } else {
      //     onFailedPasscode();
      //   }
      // } else {
      //   // Handle invalid passcode
      //   onFailedPasscode();
      // }
    },
    validationSchema: Yup.object().shape({
      passcode: Yup.string()
        .required(t('Passcode is required'))
        .min(6, t('Passcode must be 6 characters'))
        .max(6, t('Passcode must be 6 characters')),
    }),
  });

  return (
    <div className="flex flex-col items-center justify-center h-1/2">
      <h1 className="text-3xl font-bold leading-9 text-white">
        {t('This survey requires a passcode to begin.')}
      </h1>
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="flex flex-col">
          <input
            id="passcode"
            name="passcode"
            type="text"
            placeholder={t('Enter passcode')}
            className="'mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md text-gray-900"
            value={values.passcode}
            onChange={handleChange}
          />
          <ErrorMessage errors={errors.passcode} touched={touched.passcode} />
        </div>
        <button
          type="submit"
          className="mt-4 bg-light-primary dark:bg-dark-primary hover:bg-dark-secondaryAccent text-white dark:text-custom-gray600 font-bold py-2 px-4 rounded w-full"
        >
          {t('Submit')}
        </button>
      </form>
    </div>
  );
};

export default PasscodeForm;
